import React, {useContext, useEffect, useState, useCallback} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import BotonVolver from '../components/BotonVolver';
import AsyncSelect from 'react-select/async';
import { errorMessage } from '../errorHandler';
import resourcesServices from '../services/resourcesServices';
import TextControl from '../components/customizedInputs/TextControl';
import TextAreaControl from '../components/customizedInputs/TextAreaControl';
import CheckBoxControl from '../components/customizedInputs/CheckBoxControl';
// import ticket from '../components/ticket';
// import { Margin, usePDF } from 'react-to-pdf';
import { PDFDownloadLink } from '@react-pdf/renderer';
import ImprimirCedula from './ImprimirCedula';

const CedulaForm = () => {
  const navigate = useNavigate();
  const [authInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  // const { toPDF, targetRef } = usePDF({
  //   filename: 'page.pdf',
  //   method: "save",
  //   page: {
  //     margin: Margin.MEDIUM,
  //     // default is 'A4'
  //     format: 'legal',
  //     // default is 'portrait'
  //     orientation: 'portrait',
  //  }
  // });


  const [cedula, setCedula] = useState({});
  const [esNuevo, setEsNuevo] = useState(true);
  const [mensaje, setMensaje] = useState("");
  const [saving, setSaving] = useState(false);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState({value: '', label: ''});

  let { id } = useParams();

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true){

      setEsNuevo( id === undefined )
      if(id){
        fetchCedula(id)
      } else {
        nuevaNotificacion()
      }
      
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation, id]);


  const fetchCedula = async (id) => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('cedulas', id);
      setSelectedUser(
        {
          value: data.destinatario_id,
          label: `${data.destinatario.nombre} ${data.destinatario.apellido}`
        }
      )
      setCedula(data);
      setMensaje(data.mensaje)
    } catch (error) {
      errorMessage(error)
    }
  };

  const nuevaNotificacion = async (id) => {
    try {
      const data = await resourcesServices.nuevoResource('cedulas');
      setCedula(data);
      setMensaje("")
    } catch (error) {
      errorMessage(error)
    }
  };


  const guardarCedula = async () => {
    try {
      setSaving(true)
      const attributeName = 'cedula'
      const copiaCedula = {...cedula}
      copiaCedula.destinatario_id = selectedUser.value

      const formData =  new FormData();
      for(const [key, value] of Object.entries(copiaCedula)){
        if(value !== null){
          if(key === "firma"){
            for(let i = 0; i < value.length; i++){
              formData.append(`${attributeName}[${key}]`, value.item(i), value.item(i).name)
            }
          } else {
            formData.append(`${attributeName}[${key}]`, value)
          }
        }
      }

      if(esNuevo){
        await resourcesServices.crearResource('cedulas', formData, Array.from(formData.keys()).length !== 0);
      } else {
        await resourcesServices.actualizarResource('cedulas', copiaCedula.id, formData);
      }

      setSaving(false)

      navigate(`/cedulas`);

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };


  const handleInput = (e) => {
    const { name, value } = e.target;

    if(name === 'tiene_copias'){
      setCedula({...cedula,
        [name]: !cedula.tiene_copias
      })
    } else {
      setCedula({...cedula,
        [name]: value
      })
    }

  }

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setCedula({...cedula,
      [name]: files
    })
  };

  const handleInputNombreUsuario = async (newValue) => {
    if(newValue !== null){
      setSelectedUser(newValue)
      setCedula({...cedula,
        ['usuario_notificado_id']: newValue.value
      })
    }
  }

  const buscarUsuarios = async(inputValue) => {
    try {
      const results = await resourcesServices.obtenerResources('usuarios', '', {query: inputValue});

      const usuarioOptions = results.data.map((usuario) => ({
        value: usuario.id,
        label: `${usuario.nombre} ${usuario.apellido}`,
      }));

      return usuarioOptions;
    } catch (error) {
      console.error('Error al buscar usuarios:', error);
      return {};
    }
  }


  return (
    <div>
      {renderHTML && (
        <>
        <h1>Cedula <BotonVolver /></h1>

        <div className="card">
          <div className="card-body px-0 pb-2 ms-3 me-3">
            <form>
              <div className='row'>
                <div className='col-sm-6'>
                  <label>Destinatario</label>
                  <div className="mb-3">

                    <AsyncSelect
                        loadOptions={(e) => buscarUsuarios(e)}
                        placeholder="Buscar por nombre..."
                        onChange={(e) => handleInputNombreUsuario(e)}
                        value={selectedUser}
                        options={defaultOptions}
                        defaultOptions
                        isClearable
                      />

                  </div>
                </div>
                <div className='col-sm-6'>
                  <TextControl
                    value={cedula.domicilio}
                    name={'domicilio'}
                    handleInput={handleInput}
                    />
                </div>
                <div className='col-sm-6'>
                  <TextControl
                    value={cedula.caracter}
                    name={'caracter'}
                    handleInput={handleInput}
                    label='Carácter'
                    />
                </div>
                <div className='col-sm-6'>
                  <TextControl
                    value={cedula.expediente}
                    name={'expediente'}
                    handleInput={handleInput}
                    />
                </div>
                <div className='col-sm-6'>
                  <TextControl
                    value={cedula.sector}
                    name={'sector'}
                    handleInput={handleInput}
                    />
                </div>
                <div className='col-sm-6'>
                  <div className='row'>
                      <div className='col'>
                        <CheckBoxControl
                          value={cedula.tiene_copias}
                          name={'tiene_copias'}
                          handleInput={handleInput}
                          condition={cedula.tiene_copias}
                          />
                      </div>
                      <div className='col'>
                        {
                          cedula.tiene_copias && (
                            <TextControl
                              value={cedula.fojas}
                              name={'fojas'}
                              handleInput={handleInput}
                              type={'number'}
                              />  
                          )
                        }
                      </div>
                  </div>


                </div>  
                <div className='col-sm-6'>
                  <TextControl
                    value={cedula.expediente_caratula}
                    name={'expediente_caratula'}
                    handleInput={handleInput}
                    />
                </div>
                <div className='col-sm-6'>
                  <TextAreaControl
                    value={cedula.desarrollo}
                    name={'desarrollo'}
                    handleInput={handleInput}
                    />
                </div>
                <div className='col-sm-6'>
                  <TextControl
                    value={cedula.cedula}
                    name={'cedula'}
                    handleInput={handleInput}
                    label={'Cédula'}
                    />
                </div>
                <div className='col-sm-6'>
                  <TextAreaControl
                    value={cedula.documentos_adjuntados}
                    name={'documentos_adjuntados'}
                    handleInput={handleInput}
                    />
                </div>          
                <div className='col-sm-6'>
                  <TextControl
                    value={cedula.fecha_emision}
                    name={'fecha_emision'}
                    type={'date'}
                    handleInput={handleInput}
                    />
                </div>    
                {/* <pre>{JSON.stringify(cedula, null, 2)}</pre> */}

                {/* <div className="card mb-3">
                  <div className="card-body text-end">
                    <div className="mb-3">
                      <input placeholder="Adjunte los documentos" className="form-control" onChange={handleFileChange} name="firma" type="file" id="firma" multiple/>
                    </div>
                    {
                      cedula.firmaUrl && (
                        <img src={cedula.firmaUrl} className='img-fluid w-25' />
                      )
                    }
                  </div>
                </div> */}

                <button disabled={saving} className="btn btn-primary mt-3" onClick={() => guardarCedula()} type="button">
                  {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                  <span role="status">Guardar</span>
                </button>

                {
                  !esNuevo && (
                    <PDFDownloadLink className="btn btn-primary mt-3" document={<ImprimirCedula content={cedula} />} fileName={`cedula-${id}.pdf`}>
                      {({ blob, url, loading, error }) =>
                        loading ? 'Generando PDF...' : 'Generar PDF'
                      }
                    </PDFDownloadLink>
                  )
                }

                
              </div>
            </form>
          </div>
        </div>

        </>
      )}
    </div>
  );
};

export default CedulaForm;